import { ApiHelper } from './apiHelper';
import { ProductData, ProductFilter } from '../components/common/CommonTypes';

export class ProductApi {
  getProducts(
    productFilter: ProductFilter,
    token: string,
    successCallback: (product: ProductData) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const dataUrl = '/api/product/getProducts';

    new ApiHelper().postDataSecureAsync(
      dataUrl,
      productFilter,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
